export default __webpack_public_path__ + "static/media/INFOIcon.8415f6a9.svg";